import * as actionTypes from "store/actions/actionTypes";
import { getChargeEntryList } from "store/actions/dashboard";
import {
  setLoader,
  unSetLoader,
  setErrorMessage,
  showSnackbar,
} from "store/actions/appActions";
import axios from "axios";
import { billing } from "store/requests";
import { openFileInWindow } from "utils/helper";

export const getPracticeRates = (payload, source) => {
  return async () => {
    try {
      let { data } = await billing({
        url: "/getPracticeRates",
        payload,
        addUserName: true,
        data: { cancelToken: source ? source.token : null },
      });
      return data?.[0] || {};
    } catch (error) {}
  };
};

export const updateProviderId = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/updateProviderId",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      if (!axios.isCancel(error)) {
        dispatch(
          setErrorMessage(error?.response?.data?.error || error.message)
        );
      }
    }
  };
};

export const viewClaimForm = (payload) => {
  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/viewClaimForm",
        payload,
        addUserName: true,
        data: { responseType: "blob" },
      });
      console.log("response: ", response);
      openFileInWindow({
        response,
        ext: "pdf",
      });
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const deleteChargeEntry = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/deleteChargeEntry",
        payload,
        addUserName: true,
      });
      dispatch(getChargeEntryList());
      return data;
    } catch (error) {}
  };
};

export const getChargesDetails = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getChargeDetails",
        payload,
        addUserName: true,
      });
      return data["success"];
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const addChargeDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/addChargeDetails",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const updateChargeDetails = (payload) => {
  delete payload.modifier;
  return async (dispatch, store) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/updateChargeDetails",
        payload,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const getPatientDetails = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getPatientDetails",
        payload,
        addUserName: true,
      });
      return data?.success?.[0];
    } catch (error) {
      dispatch(
        setErrorMessage(
          error?.response?.data?.error
            ? error.response.data.error
            : error.message
        )
      );
    }
  };
};

export const updateChargeEntryFacilityClaimDetails = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/updateChargeEntryFacilityClaimDetails",
        payload,
      });
      return data;
    } catch (error) {
      dispatch(
        setErrorMessage(
          error?.response?.data?.error
            ? error.response.data.error
            : error.message
        )
      );
    }
  };
};
export const getChargeEntryFacilityClaimDetails = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getChargeEntryFacilityClaimDetails",
        payload,
      });
      return data;
    } catch (error) {
      dispatch(
        setErrorMessage(
          error?.response?.data?.error
            ? error.response.data.error
            : error.message
        )
      );
    }
  };
};

export const addPatientDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/addPatientDetails",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      if (error?.response?.data?.["Address Error"]) return error.response?.data;
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const checkDuplicatePatient = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getPatientDetails",
        payload,
        addUserName: true,
      });
      return data.success.length !== 0;
    } catch (error) {
      return null;
    }
  };
};

export const addChargeEntryAuth = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let response = await billing({
        url: "/addChargeEntryAuth",
        payload,
        addUserName: true,
      });
      return response;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const setPatient = (data) => {
  return {
    type: actionTypes.SET_PATIENT,
    details: data,
  };
};

export const getChargeEntry = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getChargeEntry",
        payload,
        addUserName: true,
      });
      if (data.success.length === 0) return;
      return data.success[0];
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const processClaim = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/claimmd/processClaim",
        payload,
        addUserName: true,
      });
      const { status } = data;
      dispatch({
        type: actionTypes.UPDATE_CLAIMS_ID,
        claim_ids: {
          status,
        },
      });
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const getClaimHistory = async (payload, source) => {
  try {
    let { data } = await billing({
      url: "/claimmd/getClaimHistory",
      payload,
      addUserName: true,
      data: { cancelToken: source ? source.token : null },
    });
    return data.claim_history;
  } catch (error) {
    if (!axios.isCancel(error)) {
      return "Failed to fetch Data";
    }
  }
};

export const makeChargeEntry = async (payload, source) => {
  try {
    let { data } = await billing({
      url: "/addChargeEntry",
      payload,
      addUserName: true,
      data: { cancelToken: source ? source.token : null },
    });
    return data;
  } catch (error) {
    if (!axios.isCancel(error)) {
      console.log("ERROR", error.response);
    }
  }
};

export const editPersonalInfo = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/editPersonalDetails",
        payload,
      });
      dispatch(setPatient(payload));
      dispatch(showSnackbar("Successfully edited patient", 4000));
      return data;
    } catch (error) {
      console.log("error>>>: ", error);
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const clearChargeEntry = () => {
  return (dispatch) => {
    // clears all charge_entry except for all patients array
    // this was changed
    dispatch({
      type: actionTypes.CLEAR_CHARGE_ENTRY,
    });
  };
};

export const getPracticeMedCodes = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getPracticeMedCodes",
        payload,
        addUserName: true,
      });
      let diagnosis = [];
      let procedure = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code_type === "ICD10") diagnosis.push(data[i]);
        else if (data[i]?.code_type === "CPT") procedure.push(data[i]);
      }
      dispatch({
        type: actionTypes.SET_CODES,
        diagnosis: diagnosis.sort((a, b) => {
          if (a.code > b.code) return 1;
          if (a.code < b.code) return -1;
          return 0;
        }),
        procedure: procedure.sort((a, b) => {
          if (a.code > b.code) return 1;
          if (a.code < b.code) return -1;
          return 0;
        }),
      });
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const getPatientChargeEntries = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getPatientDetails",
      payload,
      addUserName: true,
    });
    return data["success"].map((p) => ({
      ...p,
      id: p.charge_entry_id,
    }));
  } catch (error) {}
};

export const updateChargeEntryStatus = async (payload) => {
  try {
    let { data } = await billing({
      url: "/updateChargeEntryStatus",
      payload,
      addUserName: true,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getChargeEntryClaims = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getChargeEntryClaims",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const assignChargeEntry = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/assignChargeEntry",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const getChargeEntryClaimList = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getChargeEntryClaimList",
      payload,
      addUserName: true,
    });
    return data.success;
  } catch (error) {}
};

export const getPracticeUsers = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/getPracticeUsers",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const rejectChargeEntryClaim = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/rejectChargeEntryClaim",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const submitClaimOffline = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/submitClaimOffline",
        payload,
        addUserName: true,
      });
      dispatch(showSnackbar("Updated data successfully"));
      return data;
    } catch (error) {
      dispatch(showSnackbar("Failed to update Paper submission details"));
    }
  };
};

export const deleteChargeDetails = async (payload) => {
  try {
    let { data } = await billing({
      url: "/deleteChargeDetails",
      payload,
      addUserName: true,
    });
    return data;
  } catch (error) {
    return undefined;
  }
};

export const getUserTaggedChargeEntries = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getUserTaggedChargeEntries",
      payload,
      addUserName: true,
    });
    return data["success"];
  } catch (error) {}
};

export const addUserTaggedChargeEntries = async (payload) => {
  try {
    let { data } = await billing({
      url: "/addUserTaggedChargeEntries",
      payload,
      addUserName: true,
    });
    return data;
  } catch (error) {}
};

export const updateUserTaggedChargeEntries = async (payload) => {
  try {
    let { data } = await billing({
      url: "/updateUserTaggedChargeEntries",
      payload,
      addUserName: true,
    });
    return data;
  } catch (error) {}
};

export const deleteUserTaggedChargeEntries = async (payload) => {
  try {
    let { data } = await billing({
      url: "/deleteUserTaggedChargeEntries",
      payload,
      addUserName: true,
    });
    return data;
  } catch (error) {}
};

export const updateChargeEntry = async (payload) => {
  try {
    let { data } = await billing({
      url: "/updateChargeEntry",
      payload,
      addUserName: true,
    });
    return data;
  } catch (error) {
    return null;
  }
};
